import React from "react";
import Headers from "../../../components/Headers";
import {
  Tooltip,
  Input,
  Form,
  Row,
  Col,
  Button,
  Select,
  Table,
  Divider,
  message,
  Modal,
  Icon,
} from "antd";
import {
  fetchBusinessEquipmentList,
  fetchUnbind,
  fetchUninstall,
} from "../../../api/business";
import NProgress from "nprogress";

const BreadCrumbData = [
  { path: "/page/business", name: "商户" },
  { path: "/page/business/viewEquipment", name: "查看设备" },
];
const { Column } = Table;

class ViewEquipment extends React.Component {
  state = {
    capsuleId: "",
    isUnbindEquipment: "",
    unbindModalvisible: false,
    list: [],
    total: 0,
    listQuery: { companyId: "", pageNum: 1, pageSize: 10 },
  };
  handleCancel = () => {
    this.setState({
      unbindModalvisible: false,
    });
  };
  handleOk = () => {
    if (this.state.isUnbindEquipment) {
      console.log("解绑设备");
      fetchUnbind({ capsuleId: this.state.capsuleId }).then((res) => {
        if (res.success) {
          message.success("已解绑设备");
          this.getEquipmentList();
        }
      });
    } else {
      console.log("解除安装");
      fetchUninstall({ capsuleId: this.state.capsuleId }).then((res) => {
        if (res.success) {
          message.success("已解除安装");
          this.getEquipmentList();
        }
      });
    }
    this.handleCancel();
  };
  componentWillMount() {
    this.setState(
      {
        listQuery: {
          ...this.state.listQuery,
          companyId: this.props.match.params.id,
        },
      },
      async () => {
        NProgress.start();
        await this.getEquipmentList();
        NProgress.done();
      }
    );
  }
  getEquipmentList = () => {
    fetchBusinessEquipmentList(this.state.listQuery).then((res) => {
      console.log(res);
      this.setState({
        list: res.data.list,
        total: res.data.total,
      });
    });
  };
  renderType = (value) => {
    switch (value) {
      case "EV200":
        return "EV200";
        break;
      case "X5":
        return "X5";
        break;
      default:
        break;
    }
  };
  render() {
    const {
      capsuleId,
      list,
      total,
      listQuery,
      unbindModalvisible,
      isUnbindEquipment,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="salesData">
          <Button onClick={() => this.props.history.go(-1)}>返回</Button>
        </div>
        <div className="content">
          <Table
            rowKey="capsuleId"
            dataSource={list}
            // locale={{ emptyText: "暂无商户" }}
            pagination={{
              total: total,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getEquipmentList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getEquipmentList()
                );
              },
            }}
          >
            <Column
              title="设备类型"
              dataIndex="capsuleType"
              key="capsuleType"
              render={this.renderType}
            />
            <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
            {/* <Column
              title="收款方式"
              dataIndex="type"
              key="type"
              render={(record) =>
                record === "SHARE"
                  ? "分账收款"
                  : record === "OFFLINE_SHARE"
                  ? "线下分账"
                  : "销售"
              }
            /> */}
            <Column
              title="规则明细"
              render={(record) => "每笔订单" + record.shareRule + "%"}
            />
            <Column title="投放地点" dataIndex="address" key="address" />
            <Column
              title="安装状态"
              dataIndex="status"
              key="status"
              render={(record) => (record === "INSTALL" ? "已安装" : "未安装")}
            />
            <Column
              title="设备版本"
              dataIndex="versionName"
              key="versionName"
            />
            <Column
              title="操作"
              render={(text, record) => {
                return record.status === "UNINSTALL" ? (
                  <a
                    onClick={() =>
                      this.setState({
                        capsuleId: record.capsuleId,
                        unbindModalvisible: true,
                        isUnbindEquipment: true,
                      })
                    }
                  >
                    解绑设备
                  </a>
                ) : (
                  <React.Fragment>
                    <Tooltip
                      placement="bottom"
                      title="需先解除安装，才能解绑设备"
                    >
                      <a>解绑设备</a>
                    </Tooltip>

                    <Divider type="vertical" />

                    <a
                      onClick={() =>
                        this.setState({
                          capsuleId: record.capsuleId,
                          unbindModalvisible: true,
                          isUnbindEquipment: false,
                        })
                      }
                    >
                      解除安装
                    </a>
                  </React.Fragment>
                );
              }}
            />
          </Table>
          <Modal
            title={isUnbindEquipment ? "解绑设备" : "解除安装"}
            visible={unbindModalvisible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <Icon
              type="info-circle"
              theme="filled"
              style={{ color: "#FAAD14" }}
            />
            {isUnbindEquipment ? (
              <span>确定解绑设备？解绑后设备收回商户不能继续使用。</span>
            ) : (
              <span>确定解除设备安装？解除后设备暂不能使用。</span>
            )}
          </Modal>
        </div>
      </div>
    );
  }
}
export default ViewEquipment;
